'use client'
import React, { useEffect, useRef } from 'react'

import { POST_MESSAGE_TYPES } from '~/lib/constants/post-message'

interface MiniCartLayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: MiniCartLayoutProps) {
  const wrapperRef = useRef<HTMLDivElement>(null)

  // Height effect
  useEffect(() => {
    if (window.parent === window || !wrapperRef.current) {
      return
    }

    const wrapperElement = wrapperRef.current
    let frameId = 0

    const notifyParentAboutHeight = () => {
      window.cancelAnimationFrame(frameId)
      frameId = window.requestAnimationFrame(() => {
        const height = Math.ceil(
          Math.max(
            wrapperElement.scrollHeight,
            wrapperElement.getBoundingClientRect().height,
          ),
        ) + 5

        window.parent.postMessage(
          {
            type: POST_MESSAGE_TYPES.RESIZE_IFRAME,
            height,
          },
          '*',
        )
      })
    }

    const resizeObserver = new ResizeObserver(notifyParentAboutHeight)

    resizeObserver.observe(wrapperElement)

    window.addEventListener('resize', notifyParentAboutHeight)

    document.fonts.ready
      .then(notifyParentAboutHeight)
      .catch(() => {})

    notifyParentAboutHeight()

    return () => {
      window.cancelAnimationFrame(frameId)
      resizeObserver.disconnect()
      window.removeEventListener('resize', notifyParentAboutHeight)
    }
  }, [])

  return (
    <div className="wrapper-ref bg-white overflow-x-auto w-full p-0" ref={wrapperRef}>
      {children}
    </div>
  )
}
